import { useCurrentUserQuery } from '@/hooks/user/queries/use-current-user.query';
import FormInputField from '@/components/ui/form-input-field';
import { FormProvider } from '@/contexts/form-context';
import GeneralPanelFooter from './general-panel-footer';
import { useUpdateUserForm } from '@/hooks/user/use-update-user.form';

function GeneralPanel() {
  const query = useCurrentUserQuery();
  const form = useUpdateUserForm(query.data);

  return (
    <div className="grow">
      <FormProvider form={form}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            form.handleSubmit();
          }}
        >
          <div className="p-6 space-y-6 max-w-lg">
            <h2 className="text-2xl text-gray-800 dark:text-gray-100 font-bold mb-5">Allmänt</h2>
            <div className="flex flex-col lg:flex-row gap-6">
              <FormInputField name="firstName" label="Förnamen" />
              <FormInputField name="lastName" label="Efternamn" />
            </div>
            <FormInputField name="email" label="E-post" />
            <FormInputField name="mobileNumber" label="Mobilnummer" />
          </div>
          <GeneralPanelFooter />
        </form>
      </FormProvider>
    </div>
  );
}

export default GeneralPanel;
